<template>
  <div class="credit-card">
    <span class="type"><img :src="data.processor.image['@2x']" width="30"></span>
    <span class="lastDigits">{{ data.lastDigits }}</span>

    <button class="trash" @click="destroy(data.id)"></button>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data () {
    return {}
  },
  methods: {
    destroy (id) {
      this.$emit('destroy', id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import '../assets/sass/variables';

  .credit-card {
    position: relative;
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-right: 24px;
  }

  .type {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-right: 7px;
  }

  .lastDigits {
    font-size: .9rem;
    color: $grey-light;
    line-height: .7rem;
  }

  .trash {
    position: absolute;
    right: 8px;
    top: 4px;

    opacity: 0;
    transform: scale(.5);

    border: none;
    width: 15px; height: 15px;
    background: transparent $deleteIcon no-repeat center center;
    background-size: contain;
    cursor: pointer;
    transition: .3s all;
  }

  div:hover > .trash {
    opacity: 1;
    transform: scale(1);
  }

</style>
